let channel = null;

if (process.client && 'BroadcastChannel' in window) {
    channel = new BroadcastChannel('auth_channel');
}

export const notifyAuthChange = isAuth => {
    if (channel) {
        channel.postMessage({ isAuth });
    }
};

export const listenAuthChange = async callback => {
    if (channel) {
        channel.onmessage = event => {
            if (event?.data?.isAuth !== undefined) {
                callback(event.data.isAuth);
            }
        };
    }
};

export const closeChannel = () => {
    if (channel) {
        channel.close();
    }
};
